<template>
  <div class="searchList">
    <top-component></top-component>
    
    <div class="Coalition-content">

        <SearchComponent @submitForm="submitForm"></SearchComponent>
     
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'

  import SearchComponent from '../../components/SearchComponent'
  import Cookies from 'js-cookie'
  export default {
    name: 'SearchList',
    data() {
      return {
        
      }
    },
    mounted() {
      
    },
    methods: {     
      // 跳转到具体的商品列表
      submitForm(data) {
        this.$router.push({ name: 'SearchResult', params: data })
      }
    },
    components: {
      BottomComponent,
      TopComponent,
      SearchComponent
    }
  }
</script>

<style scoped lang="scss">
  .ChildsCoalition {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  /* 1 */
  .Coalition-title {
    height: 90px;
    width: 100%;
    background-image: url('../../assets/images/TopChild.png');
  }

  .Coalition-title-font {
    width: 1180px;
    height: 100%;
    display: flex;
    align-items: center;
    margin-left: calc(50% - 590px);
    color: rgba(0, 0, 0, 1);
    font-size: 24px;
    font-weight: 600;
  }

  /* 2 */
  .Coalition-content {
    width: 1180px;
    /* height: 500px; */
    margin-left: calc(50% - 590px);
  }

  .Coalition-contentFor {
    margin-top: 20px;
  }

  .Coalition-contentFor-title {
    color: rgba(0, 0, 0, 1);
    font-size: 18px;
    margin-left: 5px;
    height: 40px;
    display: flex;
    align-items: center;
    margin-top: 20px;
  }

  .Coalition-contentFor-content {
    width: 190px;
    height: 40px;
    display: inline-block;
    line-height: 40px;
    border-radius: 4px;
    margin-left: 5px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
    margin-top: 10px;
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/search/SearchList.vue